import { render, staticRenderFns } from "./ListClientCompany.vue?vue&type=template&id=4e2acc6a&scoped=true&"
import script from "./ListClientCompany.vue?vue&type=script&lang=js&"
export * from "./ListClientCompany.vue?vue&type=script&lang=js&"
import style0 from "./ListClientCompany.vue?vue&type=style&index=0&id=4e2acc6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2acc6a",
  null
  
)

export default component.exports